<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title pl-3">Notifications </h1>
        </div>
        <div class="content-section p-5">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <ul class="card">
                        @for (not of notificationData | paginate: { itemsPerPage: itemPerPage, currentPage: currentPage,
                        totalItems: total }; track not?._id; let i = $index ) {
                        <li class="border card-header">
                            <div class="d-flex justify-content-space-between">
                                <label class="text-nowrap">
                                    {{ not?.userId?.email }} –
                                    {{ not?.userId?.firstName }} {{ not?.userId?.lastName }}
                                </label>
                                <label>
                                    {{ not?.createdAt | date: 'd/M/y' : 'UTC' }},
                                    {{ not?.createdAt | date: 'hh:mm a' : 'UTC' }}
                                </label>
                            </div>

                            <div class="row">
                                <div class="col">
                                    {{ not?.body }}
                                </div>
                            </div>
                        </li>
                        }



                    </ul>

                    @if(total > 10){
                    <div class="w-100 d-flex justify-content-end">
                        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                    </div>
                    }
                    <div class="pt-3">
                        <form [formGroup]="form">
                            <h5>
                                Send Notification
                            </h5>
                            <textarea (keypress)="service.preventSpace($event)" formControlName="notification"
                                maxlength="256" placeholder="Write here" class="pt-2 p-1" id="" cols="60"
                                rows="5"></textarea>
                            <div class="mt-3">

                                <div (click)="PatientListApi()">
                                    <input type="radio" formControlName="patNotification" name="patNotification"
                                        value="Patients">
                                    <label for="" class="ms-2"> Send All Patients </label>
                                </div>
                                <div (click)="PatientListApi()">
                                    <input type="radio" formControlName="patNotification" name="patNotification"
                                        value="Therapists">
                                    <label for class="ms-2"> Send All Therapists </label>
                                </div>
                                <div>
                                    <input type="text" maxlength="20" formControlName="search"
                                        placeholder="Search by name" class="col-md-3 form-control" id="">
                                    @if(form.controls.search.value!=''){
                                    <div>
                                        <div class="col-sm-4 mt-3 p-0">
                                            @for (name of patientListData; track name; let i = $index) {
                                            <div (click)="selectUser(name?._id)"
                                                class="border d-flex align-items-center mt-1"
                                                style="cursor: pointer;background-color: #d3d3d369;;">
                                                <input type="radio" name="name" id="">
                                                <p class="ms-2 mt-3">
                                                    {{name?.firstName}} {{name?.lastName}}

                                                </p>
                                            </div>
                                            }
                                            <div class="border d-flex align-items-center mt-1"
                                                style="cursor: pointer;background-color: #d3d3d369;;">
                                                @if(!patientListData.length){
                                                <p class="ms-2 mt-3">
                                                    No Patient/Therapist found !
                                                </p>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </form>

                    </div>

                    <div class="mt-3 text-center">
                        <button class="btn btn-theme" [disabled]="form.invalid"
                            (click)="sendNotification()">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>